/**
 * Manual modal open/close (without Bootstrap Modal JS) must sync ARIA state.
 * Otherwise aria-hidden="true" remains while focus moves inside → accessibility violations.
 */

export function setModalAccessibleOpen(modalEl) {
  if (!modalEl) return;
  modalEl.setAttribute('aria-hidden', 'false');
  modalEl.setAttribute('aria-modal', 'true');
}

export function setModalAccessibleClosed(modalEl) {
  if (!modalEl) return;
  const active = document.activeElement;
  if (active && typeof active.blur === 'function' && modalEl.contains(active)) {
    active.blur();
  }
  modalEl.setAttribute('aria-hidden', 'true');
  modalEl.removeAttribute('aria-modal');
}
